import { render, staticRenderFns } from "./form-question.vue?vue&type=template&id=297df89a&scoped=true"
import script from "./form-question.vue?vue&type=script&lang=js"
export * from "./form-question.vue?vue&type=script&lang=js"
import style0 from "./form-question.vue?vue&type=style&index=0&id=297df89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297df89a",
  null
  
)

export default component.exports